module.exports = __webpack_public_path__ + "img/marker_green.b4f32c7.svg";